import { Component, OnInit, OnDestroy, Input, Inject, Optional } from '@angular/core';
import { IAuthorizationService, PershingTranslationService } from '@pershing/pershing-core';
import { NxiConfigUtil } from '@pershing/nxi-common';
import { NavigationEnd, Router } from '@angular/router';
import { Location, formatDate } from '@angular/common';
import { PortalComponentService } from '../services/portal-component.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'nxi-header',
    templateUrl: 'header.component.html'
})
export class NxiHeaderComponent implements OnDestroy, OnInit {
    @Input() showLogoOnly: boolean = false;
    @Input() hideLogoutButton: boolean = false;
    @Input() hideQuickQuote: boolean = false;
    @Input() isAdaTheme: boolean;
    @Input() showLanguageSwitch: boolean = false;
    @Input() isLoggedIn: boolean = false;
    @Input() isAccountOpeningPageADA: boolean = false;
    @Input() hideOpenAccounLink: boolean = false;
    showExit: boolean = false;
    isPotentialUser: boolean = false;
    passwordExpiryDays: number;
    hideLastLoginTime: boolean;
    lastLoginTime: string;
    isGeneric: boolean = true;
    isVendorSso: boolean = false;
    isPreLoginLinkADAenabled: boolean;
    isNewAcctOpeningEnabled: boolean;
    isEdelOnly: boolean;
    isSpanish: boolean;
    isAdvisor: boolean;
    isThemeSelector: boolean = false;
    isEdelPromoPage: boolean;
    showLoginLink: boolean = false;
    isDisclosuresPage: boolean = false;
    ibdName: string;
    clearingInfoDisplayed: boolean;
    ibd: string;
    userId: string;
    loginUrl: string = '/nxi/login';
    preloginUrl: string = '/nxi/prelogin';
    ibdCustSupportPhone: string;
    skipNav: string;
    isMobileTheme: boolean = false;
    isTabletTheme: boolean = false;
    isShowSwitchTheme: boolean = false;
    showModernThemeLink: boolean = false;
    currentUrl: any;
    isCBOL: boolean = false;
    doShowInvestingHeader: boolean = false;
    isSSOLogoutHide: boolean = false;
    isLoggedInUser: boolean = false;
    isOldAccOpenEnabled: boolean;
    isConnectibd: boolean = false;
    subs: Subscription;
    subs1: Subscription;
    disableAcctOpenLink: boolean;
    taggedValue: any;
    constructor(
        private router: Router,
        private authorizationService: IAuthorizationService,
        private portalComponentService: PortalComponentService,
        private location: Location,
        private translationService: PershingTranslationService,
        @Optional() @Inject('AppSettings') appSettings: any) {
        this.translationService.addTranslationFolder('@pershing/nxi-common', 'node_modules/@pershing/nxi-common/lib');
        this.translationService.addTranslationFolder('@pershing/nxi-portalcomponents', 'node_modules/@pershing/nxi-portalcomponents/lib');
        if (NxiConfigUtil.getCommunityName(appSettings) !== 'netxinvestor') {
            this.isGeneric = false;
        }
        if(appSettings) {
            if (appSettings.ibdConfigMap) {
                let parsemap = appSettings.ibdConfigMap;
                this.disableAcctOpenLink = parsemap.disableAcctOpenLink;
                this.isPreLoginLinkADAenabled = parsemap.enablePreloginAdaLink;
                this.ibdName = parsemap.ibdName;
                this.clearingInfoDisplayed = parsemap.clearingInfoDisplayed && !appSettings.isSitebuilder;
                this.ibd = parsemap.IBD;
                this.ibdCustSupportPhone = parsemap.ibdCustSupportPhone;
                this.isAdvisor = appSettings.isAdvisor;
                this.isLoggedInUser = appSettings.isLoggedIn;
                this.isPotentialUser = appSettings.isPotentialUser;
                this.isGeneric = parsemap.generic;
                if (!!this.isGeneric) {
                        this.isNewAcctOpeningEnabled = parsemap.isGenericNewAccOpenEnabled && this.authorizationService.isEntitled('ACCOUNT_OPENING');
                } else {
                        this.isNewAcctOpeningEnabled = parsemap.isNewAccOpenEnabled && this.authorizationService.isEntitled('ACCOUNT_OPENING');
                }
                this.isOldAccOpenEnabled = parsemap.isAccOpenEnabled && this.authorizationService.isEntitled('ACCOUNT_OPENING');
                this.doShowInvestingHeader = (parsemap.IBD === 'C01' || parsemap.IBD === 'H1X') && !this.isGeneric && this.checkNAOPage(this.location);
            }
            if (!appSettings.isModernTheme && appSettings.region !== 'qa' && appSettings.region !== 'prod') {
                this.showModernThemeLink = true;
            }
            if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
                this.isMobileTheme = true;
            } else if (appSettings.deviceType && appSettings.deviceType === 'tablet') {
                this.isTabletTheme = true;
            } else if (appSettings.themeType && appSettings.themeType === 'ada') {
                this.isAdaTheme = true;
            }
            if (appSettings.isVendorSso) {
                // this.isVendorSso = appSettings.isVendorSso;
            }
            if (appSettings.isCBOL) {
                this.isCBOL = appSettings.isCBOL;
            }
            if (appSettings.ibdConfigMap.community === 'equipt' && appSettings.isVendorSso) {
                this.hideLastLoginTime = true;
            }
            if (appSettings.isSSOLogoutHide) {
            this.isSSOLogoutHide = appSettings.isSSOLogoutHide;
            }
        }
        let url = this.location.path(false);
        let urlArray = url.split('/');
        if (urlArray[2] === 'disclosure') {
            this.showLoginLink = true;
            this.isDisclosuresPage = true;
        }
        if (url.includes('/theme-selector')) {
            this.isThemeSelector = true;
        }
        if (url.includes('edelivery-promotion')) {
            this.isEdelPromoPage = true;
        }
        this.resolveUrlFlags(url);
        this.userId = sessionStorage.getItem('nxiUserId');
        if (this.ibd === 'TXZ') {
            this.isConnectibd = true;
        }
    }
    resolveUrlFlags(url) {
        if (url.includes('account-info-entry-nao') || url.includes('account-status-nao') ||
                url.includes('account-types-nao') || url.includes('account-creation-info-nao') ||
                url.includes('account-verid-nao') || url.includes('account-verid-qa-nao') || url.includes('account-new-userid-nao') ||
                url.includes('what-next') || url.includes('account-congrats-nao') || url.includes('add-fundstransfer') ||
                url.includes('digital-advise-splash') || url.includes('digital-advise-mixin') || url.includes('dt-consent') || url.includes('prospectAccount-login')
				|| url.includes('dtAccountTransferConfirm') || url.includes('prospectAccounts')) {
                    if (this.isPotentialUser) {
                        this.showExit = true;
                    } else {
                        this.isAccountOpeningPageADA = true;
                    }
                    this.hideQuickQuote = true;
        } else {
            this.showExit = false;
            this.isAccountOpeningPageADA = false;
        }
    }
    ngOnInit() {
        this.isLoggedIn = this.isLoggedInUser;
        if (this.isLoggedIn) {
            this.isEdelOnly = this.authorizationService.isEntitled('EDELIVERY_ONLY');
            this.getLastLogonTime();
        }
        this.subs = this.router.events.subscribe((url: any) => {
            // console.log('current url auth' + url.url);
            if (url.url) {
                this.currentUrl = url.url;
            }
            // Treat the duplicate confirmation screen as prelogin screen to hide logout
            // and other components.
            if (this.currentUrl.includes('duplicatesessionconfirmation')) {
                this.isLoggedIn = false;
            }
            this.resolveUrlFlags(this.currentUrl);
            if (this.currentUrl.includes('add-fundstransfer') || this.currentUrl.includes('account-congrats-nao') || this.currentUrl.includes('account-status-nao')) {
                this.hideQuickQuote = true;
            }
            if (this.isAdaTheme) {
                if (!this.currentUrl.includes('alldocuments')) {
                    if (this.currentUrl.split('?').length > 1) {
                        this.currentUrl = this.currentUrl.split('?')[0];
                    }
                }
                if (this.currentUrl.split('#').length > 1) {
                    this.currentUrl = this.currentUrl.split('#')[0];
                }
                if (this.currentUrl.split(';').length > 1) {
                    this.currentUrl = this.currentUrl.split(';')[0];
                }
                this.skipNav = this.currentUrl + '#skip-nav';
            }
            if (this.currentUrl.includes('/login') || this.currentUrl.includes('/login1') || this.currentUrl.includes('/welcome')) {
                this.showLogoOnly = true;
            }
            //detect route navigation finished
            if (url instanceof NavigationEnd) {
                if ((url.urlAfterRedirects.includes('/welcome')) && this.ibd === 'QYZ') {
                    this.isShowSwitchTheme = !(this.isMobileTheme || this.isTabletTheme);
                } else {
                    this.isShowSwitchTheme = false;
                }
                if (url.urlAfterRedirects.includes('/welcome')) {
                    this.showLogoOnly = true;
                }
            }
            if (this.currentUrl.includes('/login1')) {
                this.loginUrl = '/nxi/login1';
            } else {
                this.loginUrl = '/nxi/login';
            }
        });

        if (!this.skipNav) {
            this.skipNav = window.location.pathname + '#skip-nav';
        }
        console.log(' In NxiHeaderComponent OnInit ');
    }
    public ngOnDestroy() {
        console.log(' In NxiHeaderComponent Destroy ');
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (this.subs1) {
            this.subs1.unsubscribe();
        }
    }
    logout(): void {
        var accountApplicationUniqueId = "accountApplicationUniqueId";
        if(window['tms_tag']) {
              this.taggedValue ={event : 'linkClick' , link : { name : 'exit' , type : 'link'}};
              window['tms_tag'].push(this.taggedValue);
        }
        document.dispatchEvent(new CustomEvent('portal.LogoutEvent'));
    }

    openAnAccount(): void {
        sessionStorage.removeItem('activeDTAccount');
        sessionStorage.removeItem('isDTFlow');
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
                'gotoPage': '/nxi/account-types-nao',
                'gotoParams': { fromLogin: true }
            }
        }));
        // this.router.navigate(['/nxi/account-types-nao']);
    }

    getLastLogonTime(): void {
        this.subs1 = this.portalComponentService.getLastLoginTime(this.ibd, this.userId).subscribe(
            response => {
                console.log('retrieving the last login and password expiry days : ', response);
                if (response) {
                    // this.passwordExpiryDays = response.passwordExpiryDays;
                    if (response.lastLogonTime) {
                        this.lastLoginTime = response.lastLogonTime;
                    } else {
                        let currentdate = new Date();
                        this.lastLoginTime = formatDate(currentdate, 'MMM dd, YYYY h:mm a', '');
                    }
                }
            }
        );
    }

    checkNAOPage(location): boolean {
        let url = location.path(false);
        if (url.includes('account') && (url.includes('-nao'))) {
            return false;
        }
        return true;
    }
}
